module.exports = __webpack_public_path__ + "static/results-5f4ca190ce8ce9d71447b5cc3d24f553.png";